module.exports = __webpack_public_path__ + "static/media/bulk_ppc_sample.244b35d9.csv";